export const tipoAgente = [
  {
    id: 'COMERCIALIZADOR',
    nome: "Comercializador",
    descricao: "",
    ativo: true,
  },
  {
    id: 'CONSUMIDOR_LIVRE',
    nome: "Consumidor Livre",
    descricao: "",
    ativo: true,
  },
  {
    id: 'AUTOPRODUTOR',
    nome: "Autoprodutor",
    descricao: "",
    ativo: true,
  },
  {
    id: 'AUTOIMPORTADOR',
    nome: "Autoimportador",
    descricao: "",
    ativo: true,
  },
  {
    id: 'CONSUMIDOR_CATIVO',
    nome: "Consumidor Cativo(pré-análise)",
    descricao: "",
    ativo: true,
  },
  {
    id: 'CONSUMIDOR_CATIVO_PARA_CONSUMIDOR_LIVRE',
    nome: "Consumidor Cativo para Consumidor Livre",
    descricao: "",
    ativo: true,
  },
];
